// extracted by mini-css-extract-plugin
export default {"tagsContainer":"TagsList_tagsContainer__kCnY6","header":"TagsList_header__yju9L","noReasons":"TagsList_noReasons__c3kY4"};